import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {NgClass, NgIf} from '@angular/common';

const PossibleMode = {
  LF: 'LF' as 'LF',
  c: 'contacts' as 'contacts',
  P: 'paragraph' as 'paragraph',
}
type PossibleMode = (typeof PossibleMode)[keyof typeof PossibleMode];
export {PossibleMode};

@Component({
    selector: 'app-need-help',
    templateUrl: './need-help.component.html',
    styleUrls: ['./need-help.component.scss'],
    standalone: true,
    imports: [NgClass, NgIf, TranslateModule]
})
export class NeedHelpComponent implements OnInit {

  @Input() showTitle: boolean = true;
  @Input() showSubtitle: boolean = true;
  @Input() type: PossibleMode = 'LF';
  @Input() contact;

  @ViewChild('mailTo') mailToBox;

  constructor() { }

  ngOnInit(): void {
    if (this.type === 'LF' && !this.contact) {
      this.contact = {
        lastname: 'S.',
        firstname: 'Tiao',
        email: 'hello@livin-france.com',
        avatar: 'LF-team/pp-tiao.png'
      };
    }
  }


  openChat() {
    if (this.type == 'LF') {

      // Must be on mobile only elements
      const fixed = document.getElementsByClassName('hiding_for_hubspot');
      if (fixed && fixed.length > 0) {
        for (let i = 0; i < fixed.length; i++) {

          if (fixed[i].classList.contains('hide')) {
            fixed[i].classList.remove('hide');
          } else {
            fixed[i].classList.add('hide');
          }
        }
      }

      const hubspotChat = document.getElementById('hubspot-messages-iframe-container');
      if (hubspotChat) {
        hubspotChat.classList.add('showHubSpot');
        hubspotChat.classList.remove('hideHubSpot');
      }
      // @ts-ignore
      if (window.HubSpotConversations) {
        // @ts-ignore
        window.HubSpotConversations.widget.open();

      }
    } else if (this.type == 'contacts') {
      if (this.mailToBox) {
        this.mailToBox.nativeElement.click();
      }
    }
  }

}
